import MerchCategoryModal from './MerchCategoryModal';

export default MerchCategoryModal;
